"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const webview_app_1 = require("@/webview_app");
const functions_1 = require("@/common/functions");
function default_1({ viewUrl, maxWidth768, isMasonryMobile, isHotCommission, children, }) {
    return ((0, jsx_runtime_1.jsx)("a", Object.assign({ href: viewUrl, onClick: e => (0, webview_app_1.stackRoomViewPage)({ roomViewUrl: viewUrl, e }), className: "no_anchor_deco", css: {
            flexShrink: 0,
            position: 'relative',
            display: 'flex',
            aspectRatio: maxWidth768 && isMasonryMobile ? 'unset' : isHotCommission ? '1 / 1' : '25 / 19',
            width: isHotCommission ? '120px' : 'unset',
            borderRadius: '10px',
            overflow: 'hidden',
            isolation: 'isolate',
            '&:after': (0, functions_1.afterImgWrapper)({ borderRadius: '10px' }),
        }, draggable: "false" }, { children: children })));
}
exports.default = default_1;
